'use strict';
var utils = require('./utils');
window.addEventListener('load', function() {
    productsCrossDataManager.updateItemByCrossInfos(viewData);
    if (dataLayer) {
        utils.pushToGtm(viewData);
    }
});
